import { GigaUserApi, GigaUserApiClient } from "@giga-user-fern/api";
import {
	AddBackgroundToOrganizationRequest,
	Background,
	Cover,
	CoverOption,
	CoverType,
	CreateOrganizationTemplateRequest,
	FaviconInputType,
	FeatureFlags,
	GeneratePreviewAudioRequest,
	GetHelpCenterConfigRequest,
	GetPronDictEntryRequest,
	GetPronDictRequest,
	GetUsageRequest,
	HostingDetails,
	InitResponse,
	Language,
	PronDictEntryRequest,
	SetDefaultTransitionRequest,
	SetHelpCenterConfigRequest,
	User,
	UserInOrg,
	UserRole,
	VideoFormat,
} from "@giga-user-fern/api/types/api";
import { LogoInputType } from "@giga-user-fern/api/types/api/resources/admin/types";
import {
	AdvancedSettings,
	AutoUpdateGuideRequest,
	BroadcastBot,
	BroadcastPlatform,
	ConvertToGifResponse,
	DeleteChatForAGuideRequest,
	DeleteMessageByIdRequest,
	FileFormat,
	FinishCreateGuideRequest,
	FinishUploadSourceRequest,
	GifSettings,
	GuideRequest,
	MoveGuideRequest,
	OriginalEdits,
	Prompt,
	PromptOption,
	PromptType,
	ReorderGuideRequest,
	SendMessageRequest,
	ValidateGuideUrlRequest,
} from "@giga-user-fern/api/types/api/resources/guides";
import { AuthType } from "@gigauser/common/src/core/types/admin";
import {
	getDataUris,
	getHTMLandTextWithImages,
} from "../components/formats/RichText/utils/exportProcessing";
import { Collection, CollectionInput } from "../core/types/collections";
import {
	Guide,
	GuideCreationType,
	GuideData,
	GuidePreview,
	Organization,
	Voice,
} from "../core/types/guide";
import { setBranding } from "../core/utils/styleUtils";
import { GuideFile, rootCollection } from "../types/files";
import logger from "../utils/logger";
import { fetcher } from "./Adapter";

import {
	CutsVideoChapters,
	ValidateCollectionUrlPathRequest,
} from "@giga-user-fern/api/types/api/resources/collections";
import {
	CustomDomainSetupRequest,
	GetHelpCentersUrlsResponse,
	UpdateOrValidateDnsRecordRequest,
} from "@giga-user-fern/api/types/api/resources/helpcenter";
import {
	SlackChannel,
	VisibilityStatus,
} from "@giga-user-fern/api/types/api/resources/integrations";
import {
	AddUserToOrganizationRequest,
	BasePlanDetails,
	ChangeOpenDoorPolicyRequest,
	ChangeRoleForUserRequest,
	CheckoutRequest,
	CreateOrganizationRequest,
	DeleteLogoRequest,
	FinishLogoUploadRequest,
	JoinOrganizationRequest,
	RemoveUserFromOrgRequest,
	UpdateLogoRequest,
	UsageMetricsRequest,
	UtilizationRequest,
} from "@giga-user-fern/api/types/api/resources/organizations";
import { APIResponse, Supplier } from "@giga-user-fern/api/types/core";
import { UploadErrorCode } from "@gigauser/common/src/types/errors";
import {
	cleanJSON,
	cleanSyncMarkers,
	insertImageMetadata,
} from "../components/formats/RichText/utils/cleanImageSrc";
import { AuthErrorCode } from "../types/errors";
import { getFonts } from "../utils/fontsUtils";
import saverconfig from "./_saverconfig";
import {
	dataURItoBlob,
	uploadToPresigned,
	uploadToPresignedXhr,
} from "./_saverfunctions";
import { Configs } from "./types";

const Id = GigaUserApi.Id;
type PresignedUrl = any;

export class RegionalSaver {
	api_url: string;
	mutationAPI: GigaUserApiClient;
	userAPI: GigaUserApiClient;
	token: Supplier<string>;
	organization: Organization | null;
	hostname: string | null;
	user: User | null;
	associateOrgs: Organization[] | null;
	languages: Language[] | null;
	voices: Voice[] | null;
	helpCenters: GetHelpCentersUrlsResponse[];
	basePlanStatus: BasePlanDetails | null;
	isUserLoggedInViaSSO: boolean;
	fontsLoaded: null | string[];
	constructor(initData: { api_url: string }) {
		this.api_url = initData.api_url;
		this.mutationAPI = new GigaUserApiClient({
			token: "random",
			environment: this.api_url,
		});
		this.mutationAPI = new GigaUserApiClient({
			token: "random",
			environment: this.api_url,
		});
		this.userAPI = new GigaUserApiClient({
			token: "random",
			environment: this.api_url,
		});
		this.token = "";
		this.organization = null;
		this.hostname = null;
		this.user = null;
		this.associateOrgs = null;
		this.languages = null;
		this.voices = null;
		this.basePlanStatus = null;
		this.helpCenters = [];
		this.isUserLoggedInViaSSO = false;
		this.fontsLoaded = null;
	}

	setCurrentCollection = () => {};
	getBrandingColor = () => {
		return this.organization?.brandColor;
	};

	getOrganization = () => {
		return this.organization;
	};

	getTokenPlatform = () => {
		//@ts-expect-error
		return this.token();
	};

	handleErrors = (resp: any) => {
		console.error("Error occured", resp);
	};
	handleAuthErrors = (resp: any) => {
		console.log("Error occured during fetching KB auth details :", resp);
		const errorValues = Object.values(AuthErrorCode);
		const error_msg = resp?.error?.error ?? "UnknownError";
		if (errorValues.includes(error_msg as AuthErrorCode))
			return error_msg as AuthErrorCode;
		return AuthErrorCode.UnknownError;
	};
	handleUploadErrors = (resp: any) => {
		console.log("Error occured during guide creation", resp);
		const errorValues = Object.values(UploadErrorCode);
		const error_msg = resp?.error?.error ?? "UnknownError";
		if (errorValues.includes(error_msg as UploadErrorCode))
			return error_msg as UploadErrorCode;
		return UploadErrorCode.UnknownError;
	};
	captureEvent = (event: any) => {
		console.log("No Capture Event");
	};

	captureEventChrext = async (
		eventName: string,
		properties: Record<string, string | undefined>,
	) => {
		const token =
			typeof this.token === "function"
				? await this.token()
				: await this.token;
		const finalProperties = {
			...properties,
			organization: this.organization?.id,
		};
		this.mutationAPI.posthog.captureEvent({
			eventName: eventName,
			properties: finalProperties,
		});
	};

	// setBrandingColor = (color:string)=>{
	//     // Used in Chrext to just maintain the same color
	//     if (!this.organization){
	//         this.organization = {id: Id('') ,domain:'no.com', brandColor: color, name: 'no'}
	//     }
	// }

	initialiseWithValues = (token: string, organization: Organization) => {
		this.token = token;
		this.mutationAPI = new GigaUserApiClient({
			//auth header goes here.
			token: token,
			//Here do client side authentication and pass a token. On the backend verify the identity of the user with some other auth0
			//function to make sure that this token is valid.
			environment: this.api_url,
			fetcher: fetcher,
		});
		this.organization = organization;
		this.mutationAPI = new GigaUserApiClient({
			token: organization.id,
			environment: this.api_url,
			fetcher: fetcher,
		});
	};

	initializeExtension: (
		accessTokenSupplier: () => Promise<string>,
		headless?: boolean,
	) => Promise<Organization> = (
		accessTokenSupplier: () => Promise<string>,
		headless = false,
	) => {
		const supplyAccessToken = async () => {
			const token = await accessTokenSupplier();
			return token;
		};

		return new Promise(async (resolve, reject) => {
			if (this.user && this.organization && !headless) {
				const res = await chrome.storage.local.get("organization_id");
				if (res.organization_id === this.organization.id) {
					resolve(this.organization);
				}
			}
			this.token = supplyAccessToken;
			this.userAPI = new GigaUserApiClient({
				//auth header goes here.
				token: supplyAccessToken,
				//Here do client side authentication and pass a token. On the backend verify the identity of the user with some other auth0
				//function to make sure that this token is valid.
				environment: this.api_url,
				fetcher: fetcher,
			});
			const res = await chrome.storage.local.get("organization_id");

			const orgId = res.organization_id;
			const resp = await this.userAPI.users.login();
			if (resp.ok) {
				try {
					if (resp.body.associatedToOrg) {
						console.log(orgId);
						const res = await this.userAPI.users.initialize({
							orgId: orgId && !headless ? Id(orgId) : undefined,
						});
						if (res.ok) {
							this.languages = await this.getAllLanguages();
							this.organization = res.body.userWithOrg.org;
							if (!headless) {
								await chrome.storage.local.set({
									organization_id:
										res.body.userWithOrg.org.id,
								});
							}
							this.hostname = res.body.hostname || null;
							this.mutationAPI = new GigaUserApiClient({
								token: async () => {
									const accessToken =
										await supplyAccessToken();
									return JSON.stringify({
										organization_id:
											res.body.userWithOrg.org.id,
										token: accessToken,
									});
								},
								environment: this.api_url,
								fetcher: fetcher,
							});
							this.hostname = res.body.hostname || null;
							this.user = {
								...res.body.userWithOrg.user,
								role: res.body.userWithOrg.role as UserRole,
								organizationId: res.body.userWithOrg.org.id,
							};
							console.log(
								"resolving late, org was found",
								this.organization,
							);

							resolve(this.organization);
						}
					} else {
						reject(
							new Error(
								"User exists but is not associated to an organization",
							),
						);
					}
				} catch (e) {
					reject(null);
				}
			} else {
				if (resp.error.error === "SSOEnabledEmail_ExternalEmailError") {
					reject(
						new Error(
							"User logged in with SSO but email doesnt belong to SSO enabled org!",
						),
					);
				}
				reject(null);
			}
		});
	};

	initializePlatform: (
		accessToken: () => Promise<string>,
		headless?: boolean,
	) => Promise<Organization> = (
		accessToken: () => Promise<string>,
		headless = false,
	) => {
		return new Promise(async (resolve, reject) => {
			if (this.user && this.organization) {
				resolve(this.organization);
			}
			if (accessToken) {
				this.token = accessToken;
				this.userAPI = new GigaUserApiClient({
					//auth header goes here.
					token: accessToken,
					//Here do client side authentication and pass a token. On the backend verify the identity of the user with some other auth0
					//function to make sure that this token is valid.
					environment: this.api_url,
					fetcher: fetcher,
				});
				const orgId = !headless
					? localStorage.getItem("organization_id")
					: undefined;

				// biome-ignore lint/suspicious/noImplicitAnyLet: let is used here to allow for reassignment
				let resp;

				resp = await this.userAPI.users.loginV2();
				if (resp.ok) {
					this.isUserLoggedInViaSSO = resp.body.ssoLogin;
					if (resp.body.associatedToOrg) {
						resp = await this.userAPI.users.initializeV2({
							orgId: orgId ? Id(orgId) : undefined,
						});

						if (resp.ok) {
							this.initializePlatformWithResp(
								{
									userWithOrg: resp.body.userWithCurrentOrg,
									hostname: resp.body.currentOrgHostname,
								},
								headless,
							);
							this.getAssociatedOrganizations();

							if (
								resp.body.basePlanDetails.name !==
								GigaUserApi.organizations.BasePlanName.None
							) {
								this.basePlanStatus = resp.body.basePlanDetails;
							} else {
								this.basePlanStatus = null;
							}

							this.languages = resp.body.languages;
							this.voices = resp.body.voices;
							this.fetchHelpCenters();
						} else if (resp.error) {
							if (!headless) {
								localStorage.removeItem("organization_id");
							}
							const res = await this.initializePlatform(
								accessToken,
								headless,
							);
							resolve(res);
						}
					} else {
						reject({ userExists: true, associatedToOrg: false });
					}
				} else {
					if (
						resp.error.error ===
						"SSOEnabledEmail_ExternalEmailError"
					) {
						reject({
							loggedInWithSSOButEmailDoesntBelongToSSOOrg: true,
						});
					}
					reject(null);
				}
				if (resp.ok) {
					//@ts-expect-error
					resolve(this.organization);
				} else {
					reject(null);
				}
			}
		});
	};

	initializePlatformWithResp = (initResp: InitResponse, headless = false) => {
		const { userWithOrg, hostname } = initResp;
		if (!headless) {
			localStorage.setItem("organization_id", userWithOrg.org.id);
		}
		this.organization = userWithOrg.org;
		this.mutationAPI = new GigaUserApiClient({
			//auth header goes here.
			token: async () => {
				//@ts-ignore
				const stringAccess = await this.token();
				return JSON.stringify({
					organization_id: userWithOrg.org.id,
					token: stringAccess,
				});
			},
			//Here do client side authentication and pass a token. On the backend verify the identity of the user with some other auth0
			//function to make sure that this token is valid.
			environment: this.api_url,
			fetcher: fetcher,
		});
		// setBranding(this.organization.brandColor)
		this.hostname = hostname || null;
		this.user = {
			...userWithOrg.user,
			role: userWithOrg.role as UserRole,
			organizationId: userWithOrg.org.id,
		};
	};

	initialise: (accessToken: string) => Promise<Organization> = (
		accessToken: string,
	) => {
		return new Promise(async (resolve, reject) => {
			if (accessToken) {
				this.token = accessToken;
				this.mutationAPI = new GigaUserApiClient({
					//auth header goes here.
					token: accessToken,
					//Here do client side authentication and pass a token. On the backend verify the identity of the user with some other auth0
					//function to make sure that this token is valid.
					environment: this.api_url,
					fetcher: fetcher,
				});

				const org =
					await this.mutationAPI.organizations.organization.getOrganization();
				const host =
					await this.mutationAPI.organizations.organization.getHostname();
				if (host.ok) this.hostname = host.body;

				logger.debug("got org: ", org);

				if (org.ok) {
					this.organization = org.body;
					logger.debug("set org: ", this);
					this.mutationAPI = new GigaUserApiClient({
						token: org.body.id,
						environment: this.api_url,
						fetcher: fetcher,
					});
					logger.debug(
						"branding being set",
						this.organization.brandColor,
					);
					// setBranding(this.organization.brandColor)
					resolve(this.organization);
				} else {
					reject(org);
				}
			}
		});
	};

	saveAudio = async () => {
		const url = await this.mutationAPI.audio.saveAudio();
		if (url.ok) {
			return url.body;
		} else {
			return null;
		}
	};

	setDefaultVoice = async (voice: Voice) => {
		const url =
			await this.mutationAPI.organizations.organization.setDefaultVoice({
				voice,
			});
		return url.ok;
	};

	deleteDefaultVoice = async (voice: Voice) => {
		const url =
			await this.mutationAPI.organizations.organization.deleteDefaultVoice(
				{
					voice,
				},
			);
		return url.ok;
	};

	initialiseFromOrgId = async (orgId: string) => {
		/**
		 * Used in remote script
		 */

		logger.debug("initialiseFromOrgId: ", orgId);
		this.mutationAPI = new GigaUserApiClient({
			token: orgId,
			environment: this.api_url,
			fetcher: fetcher,
		});

		const organization =
			await this.mutationAPI.organizations.organization.getOrganizationFromId(
				{
					id: Id(orgId),
				},
			);

		const hostname =
			await this.mutationAPI.organizations.organization.getHostnameFromId(
				{
					id: Id(orgId),
				},
			);

		logger.debug("hostname: ", hostname);

		if (organization.ok) {
			this.organization = organization.body;
			setBranding(this.organization.brandColor);

			if (hostname.ok) {
				this.hostname = hostname.body;
			}

			return this.organization;
		}
		logger.error("failed", organization);
		return null;
	};

	initialiseFromHostname = async (hostname: string) => {
		this.mutationAPI = new GigaUserApiClient({
			token: "ignore",
			environment: this.api_url,
			fetcher: fetcher,
		});

		const organization =
			await this.mutationAPI.organizations.organization.getOrganizationFromHostName(
				{
					hostname: hostname,
				},
			);

		if (organization.ok) {
			this.organization = organization.body;
			setBranding(this.organization.brandColor);
			this.mutationAPI = new GigaUserApiClient({
				token: this.organization.id,
				environment: this.api_url,
				fetcher: fetcher,
			});
			return this.organization.id;
		} else {
			logger.error("failed", organization);
			return null;
		}
	};

	// checked ✅
	fetchAllGuidePreviews = async (onlyPublished = true, getRecent = false) => {
		const allGuides = getRecent
			? await this.mutationAPI.guides.guideQueries.getRecentGuidePreviews()
			: await this.mutationAPI.guides.guideQueries.getAllGuidePreviews();

		if (allGuides.ok) {
			const guidePreviews = allGuides.body;

			if (onlyPublished) {
				return guidePreviews.filter((i) => i.header.published);
			}
			return guidePreviews;
		}
		return [];
	};

	fetchHelpCenters = async () => {
		const helpCenters =
			await this.mutationAPI.helpcenter.helpcenterMutations.getHelpcenterUrls();
		if (helpCenters.ok) {
			this.helpCenters = helpCenters.body;
		}
	};

	fetchHelpCenterConfig = async (request: GetHelpCenterConfigRequest) => {
		const resp = await this.mutationAPI.admin.getHelpCenterConfig(request);
		this.handleErrors(resp);
		if (resp.ok) {
			return resp.body;
		}
		return false;
	};

	getStagingJwt = async (hcId: GigaUserApi.Id) => {
		const resp = await this.mutationAPI.admin.getStagingJwt(hcId);
		this.handleErrors(resp);
		if (resp.ok) {
			return resp.body;
		}
		return false;
	};

	setHelpCenterConfig = async (request: SetHelpCenterConfigRequest) => {
		const resp = await this.mutationAPI.admin.setHelpCenterConfig(request);
		if (resp.ok) {
			return resp.body;
		}
		return false;
	};
	setLogo = async (logo: LogoInputType) => {
		const resp = await this.mutationAPI.admin.setLogo(logo);
		if (resp.ok) {
			return resp.body;
		}
		return false;
	};
	setFavicon = async (request: FaviconInputType) => {
		const resp = await this.mutationAPI.admin.setFavicon(request);
		if (resp.ok) {
			return resp.body;
		}

		return false;
	};
	fetchAllCollections = async () => {
		const allCollections =
			await this.mutationAPI.collections.collectionQueries.getAllCollections();

		if (allCollections.ok) {
			const collections = allCollections.body;

			return collections;
		}
		return [];
	};
	fetchAllActiveCutsCollections = async () => {
		const allCollections =
			await this.mutationAPI.collections.collectionQueries.getAllActiveCutsCollections();

		if (allCollections.ok) {
			return allCollections.body;
		}
		return [];
	};

	fetchAllChildren = async (_parentId?: string, onlyPublished = true) => {
		let parentId = undefined;

		if (_parentId === "Collection_root") {
			parentId = undefined;
		} else if (_parentId) {
			parentId = GigaUserApi.Id(_parentId);
		}

		const allChildren =
			await this.mutationAPI.collections.collectionQueries.getAllChildren(
				{
					parentId: parentId,
				},
			);

		logger.debug("allChildren: ", allChildren);
		if (allChildren.ok) {
			const { guides, collections } = allChildren.body;
			if (onlyPublished) {
				const _guides = guides.filter((g) => g.header.published);
				return {
					guides: _guides,
					collections: collections,
				};
			}
			return allChildren.body;
		}
		return {
			guides: [],
			collections: [],
		};
	};

	getPath = async (id: string) => {
		logger.debug("saver getPath: ", id);

		const res =
			await this.mutationAPI.collections.collectionQueries.getPath({
				id: GigaUserApi.Id(id),
			});

		if (res.ok) {
			const path = res.body.collections;
			const full_path = [rootCollection, ...path];

			logger.debug("got path: ", full_path);

			return full_path as [Collection, ...Collection[]];
		} else {
			return false;
		}
	};

	uploadVideoChunk = async (
		chunkNumber: number,
		guideId: GigaUserApi.Id,
		data: unknown,
		formatString: VideoFormat,
		autoUpdate: GigaUserApi.Id | undefined,
	) => {
		const uploadChunkURL =
			await this.mutationAPI.guides.guideMutations.uploadVideoChunk({
				guideId: guideId,
				chunkNumber: chunkNumber,
				format: formatString,
				updateId: autoUpdate,
			});
		if (uploadChunkURL.ok) {
			const result = await uploadToPresigned(
				data,
				uploadChunkURL.body,
				this.captureEvent,
			);
			if (!result) {
				const uploadChunkURL =
					await this.mutationAPI.guides.guideMutations.uploadVideoChunk(
						{
							guideId: guideId,
							chunkNumber: chunkNumber,
							format: formatString,
							updateId: autoUpdate,
						},
					);
				if (uploadChunkURL.ok) {
					const result = await uploadToPresigned(
						data,
						uploadChunkURL.body,
						this.captureEvent,
					);
					return result;
				}
			}
			return result;
		} else {
			const uploadChunkURL =
				await this.mutationAPI.guides.guideMutations.uploadVideoChunk({
					guideId: guideId,
					chunkNumber: chunkNumber,
					format: formatString,
					updateId: autoUpdate,
				});
			if (uploadChunkURL.ok) {
				const result = await uploadToPresigned(
					data,
					uploadChunkURL.body,
					this.captureEvent,
				);
				if (!result) {
					const uploadChunkURL =
						await this.mutationAPI.guides.guideMutations.uploadVideoChunk(
							{
								guideId: guideId,
								chunkNumber: chunkNumber,
								format: formatString,
								updateId: autoUpdate,
							},
						);
					if (uploadChunkURL.ok) {
						const result = await uploadToPresigned(
							data,
							uploadChunkURL.body,
							this.captureEvent,
						);
						return result;
					}
				}
				return result;
			}
		}
		return false;
	};

	uploadImage = async (guideId: GigaUserApi.Id, data: string) => {
		const uploadChunkURL =
			await this.mutationAPI.guides.guideMutations.uploadImage(guideId);
		if (uploadChunkURL.ok) {
			const result = await uploadToPresigned(
				dataURItoBlob(data),
				uploadChunkURL.body,
				this.captureEvent,
			);
			if (result) {
				return (uploadChunkURL.body as any).fields.key
					.split("/")
					.at(-1);
			}
			return (uploadChunkURL.body as any).fields.key.split("/").at(-1);
		}
		return false;
	};

	compileVideo = async (
		totalChunks: number,
		guideId: GigaUserApi.Id,
		formatString: VideoFormat,
		autoUpdate: GigaUserApi.Id | undefined,
		onlyCheck = false,
	) => {
		const compiledVideo =
			await this.mutationAPI.guides.guideMutations.compileVideo({
				totalChunks: totalChunks,
				guideId: guideId,
				format: formatString,
				updateId: autoUpdate,
				onlyCheck: onlyCheck,
			});
		if (compiledVideo.ok) {
			return compiledVideo.body;
		} else {
			return false;
		}
	};

	search = async (text: string) => {
		const searchResults = await this.mutationAPI.guides.guideQueries.search(
			{
				text: text,
			},
		);
		if (searchResults.ok) {
			return searchResults.body;
		} else {
			return [];
		}
	};

	initiateLogoUpload = async () => {
		const resp =
			await this.mutationAPI.organizations.organizationBranding.initiateLogoUpload();
		if (resp.ok) {
			return resp.body;
		}

		return null;
	};

	finishLogoUpload = async (request: FinishLogoUploadRequest) => {
		const resp =
			await this.mutationAPI.organizations.organizationBranding.finishLogoUpload(
				request,
			);

		if (resp.ok) {
			return resp.body;
		}

		return null;
	};

	updateLogo = async (request: UpdateLogoRequest) => {
		const resp =
			await this.mutationAPI.organizations.organizationBranding.updateLogo(
				request,
			);

		if (resp.ok) {
			return resp.body;
		}

		return null;
	};

	deleteLogo = async (request: DeleteLogoRequest) => {
		const resp =
			await this.mutationAPI.organizations.organizationBranding.deleteLogo(
				request,
			);

		if (resp.ok) {
			return resp.body;
		}

		return null;
	};

	// #region -- GUIDES --

	guides = {
		// meta api to get guideData, articleSelectedPromptData, videoSelectedPromptData, articleAiChatMessages, videoAiChatMessages
		guidePlatformData: {
			get: async (id: GigaUserApi.Id, version_number?: number) => {
				const response =
					await this.mutationAPI.guides.guideQueries.getGuidePlatformData(
						{
							id: id,
							version: version_number,
							sdkVersion: "1.0.0",
						},
					);

				if (response.ok) {
					const guidePlatformData = response.body;

					return guidePlatformData;
				} else {
					return null;
				}
			},
		},
		data: {
			get: async (id: GigaUserApi.Id, version_number?: number) => {
				const rootGuides =
					await this.mutationAPI.guides.guideQueries.getGuideData({
						id: id,
						version: version_number,
						sdkVersion: "1.0.0",
					});

				if (rootGuides.ok) {
					const guideData = rootGuides.body;
					// if (guideData.video.generated?.subtitles){
					//     const blob = new Blob([guideData.video.generated?.subtitles], { type: 'text/vtt' });
					//     guideData.video.generated.subtitles = URL.createObjectURL(blob);
					// }

					return guideData;
				} else {
					return null;
				}
			},
		},
		preview: {
			get: async (id: GigaUserApi.Id) => {
				const res =
					await this.mutationAPI.guides.guideQueries.getGuidePreview({
						id: id,
					});

				return res;
			},
			update: async (guidePreview: GuidePreview) => {
				/**
				 * Used to update only the Guide Preview.
				 * (description, name, published)
				 * Do not use this to move or reorder guides.
				 */

				const res =
					await this.mutationAPI.guides.guideMutations.updateGuidePreview(
						guidePreview,
					);

				if (res.ok) {
					return res;
				}

				return false;
			},
		},
		update: {
			data: async (guide: Guide, incrementVersion = true) => {
				/**
				 * Used to update the entire Guide (i.e: GuidePreview + GuideData)
				 */

				const { id, guidePreview, guideData } = guide;
				const sanitizedGuide: GuideData = JSON.parse(
					JSON.stringify(guideData),
				);
				sanitizedGuide.plainDoc.data = cleanJSON(
					sanitizedGuide.plainDoc.data,
				);
				if (sanitizedGuide.video.generated) {
					sanitizedGuide.video.generated.transcript.data =
						cleanSyncMarkers(
							sanitizedGuide.video.generated.transcript.data,
						);
				}

				const updateData =
					await this.mutationAPI.guides.guideMutations.updateGuideData(
						{
							id: id,
							guidePreview: guidePreview,
							guideData: sanitizedGuide,
						},
					);

				if (updateData.ok) {
					const presignedURLs = updateData.body.presignedUrls;
					const promiseArray: Promise<Response | null | false>[] = [];

					const sanitisedWithID: any = insertImageMetadata(
						JSON.parse(JSON.stringify(guideData.plainDoc.data)),
						presignedURLs.images!,
						(src: string, index: number) => {
							logger.debug("UPLOADING DATA URI", src);
							const imageUpload = uploadToPresigned(
								dataURItoBlob(src),
								presignedURLs.images?.[index],
								this.captureEvent,
							);
							promiseArray.push(imageUpload);
						},
					);
					const fullGuide: Guide = {
						...guide,
						guideData: JSON.parse(JSON.stringify(guide.guideData)),
					};
					fullGuide.guideData.plainDoc.data = sanitisedWithID;
					if (fullGuide.guideData.video.generated) {
						fullGuide.guideData.video.generated.transcript.data =
							cleanSyncMarkers(
								fullGuide.guideData.video.generated.transcript
									.data,
							);
					}

					const finishUpdate =
						await this.mutationAPI.guides.guideMutations.finishUpdateGuideData(
							{
								guide: fullGuide,
								incrementVersion: incrementVersion,
							},
						);

					if (finishUpdate.ok) {
						const success = await Promise.all(promiseArray);
						if (!success.find((x) => !x || x.ok === false)) {
							return finishUpdate.body;
						} else {
							return false;
						}
					}
				} else {
					return false;
				}
			},
			originalEdits: async (
				id: GigaUserApi.Id,
				originalEdits: OriginalEdits,
			) => {
				/**
				 * This is the save function to be run from the trim window.
				 */

				const res =
					await this.mutationAPI.guides.guideMutations.updateOriginalEdits(
						{
							id: id,
							originalEdits: originalEdits,
						},
					);
				if (res.ok) {
					return res.body;
				} else {
					return null;
				}
			},
		},
		autoUpdate: async (request: AutoUpdateGuideRequest) => {
			const id =
				await this.mutationAPI.guides.guideMutations.autoUpdateGuideVideo(
					request,
				);
			if (id.ok) {
				return id.body;
			} else {
				return null;
			}
		},
		delete: async (guideID: GigaUserApi.Id) => {
			const resp =
				await this.mutationAPI.guides.guideMutations.deleteGuide({
					id: guideID,
				});
			return resp.ok;
		},
		pin: async (pinned: boolean, guidePreview: GuidePreview) => {
			const res = await this.mutationAPI.guides.guideMutations.pinGuide({
				guidePreview: guidePreview,
				isPinned: pinned,
			});

			if (res.ok) return res;

			return false;
		},
		move: async (req: MoveGuideRequest) => {
			/**
			 * Use this function to move a guide to a new collection
			 */

			let res:
				| APIResponse<
						GigaUserApi.guides.GuidePreview,
						GigaUserApi.guides.guideMutations.moveGuide.Error
				  >
				| undefined;

			try {
				res =
					await this.mutationAPI.guides.guideMutations.moveGuide(req);
			} catch (e) {
				console.error("could not move the item: ", e);
			}

			if (res?.ok) {
				return res.body;
			} else {
				return false;
			}
		},
		reorder: async (req: ReorderGuideRequest) => {
			/**
			 * Used to reorder the sequence_number. SucceedingGuide is placed after precedingGuide
			 */

			const res =
				await this.mutationAPI.guides.guideMutations.reorderGuide(req);

			if (res.ok) return res;
			else return false;
		},
		version: {
			all: async (guide: Guide) => {
				const res =
					await this.mutationAPI.guides.guideQueries.getAllVersions({
						id: guide.id,
					});

				if (res.ok) {
					return res.body;
				} else {
					return null;
				}
			},
			restore: async (guideId: GigaUserApi.Id, version: number) => {
				const a =
					await this.mutationAPI.guides.guideMutations.restoreVersion(
						{
							id: guideId,
							version: version,
						},
					);
				if (a.ok) {
					return a.body;
				} else {
					return false;
				}
			},
		},
		create: {
			initiate: async (parentID?: GigaUserApi.Id) => {
				const id =
					await this.mutationAPI.guides.guideMutations.initiateCreateGuide(
						{
							parentId:
								parentID === rootCollection.id
									? undefined
									: parentID,
						},
					);
				if (id.ok) {
					return id.body;
				} else {
					return null;
				}
			},
			upload: async ({
				files,
				languageId,
				fileFormats,
				guideCreationType,
				parentID,
				progressCallback,
				outputLanguageId,
				advancedSettings,
			}: {
				files: GuideFile[];
				languageId: string;
				fileFormats: FileFormat[];
				guideCreationType: GuideCreationType;
				parentID?: GigaUserApi.Id;
				progressCallback?: (progress: number) => void;
				outputLanguageId?: string;
				advancedSettings?: AdvancedSettings;
			}): Promise<[string | null, UploadErrorCode]> => {
				try {
					const resp =
						await this.mutationAPI.guides.guideMutations.initiateUploadCreate(
							{
								parentId:
									parentID === rootCollection.id
										? undefined
										: parentID,
								fileFormats: fileFormats,
								guideCreationType: guideCreationType,
							},
						);
					if (!resp.ok) return [null, this.handleUploadErrors(resp)];

					const { id, urls } = resp.body;
					const status = [...Array(files.length).fill(false)];
					for (let i = 0; i < files.length; i++) {
						status[i] = await uploadToPresignedXhr(
							files[i].file as Blob,
							urls[i],
							progressCallback,
							this.captureEvent,
						);
					}

					if (!status.every((elem) => elem === true))
						return [null, UploadErrorCode.S3UploadError];

					const res =
						await this.mutationAPI.guides.guideMutations.finishUploadCreate(
							{
								id: id,
								languageId: languageId,
								fileFormats: fileFormats,
								guideCreationType: guideCreationType,
								outputLanguageId: outputLanguageId,
								advancedSettings: advancedSettings,
							},
						);
					if (!res.ok) return [null, this.handleUploadErrors(res)];

					return [id, UploadErrorCode.OK];
				} catch (error) {
					return [null, this.handleUploadErrors(error)];
				}
			},
			uploadAndSplit: async (
				file: GuideFile,
				languageId: string,
				fileFormat: FileFormat,
				parentID?: GigaUserApi.Id,
				progressCallback?: (progress: number) => void,
			): Promise<[GigaUserApi.Id | null, UploadErrorCode]> => {
				try {
					const currentTime = new Date();
					const options: Intl.DateTimeFormatOptions = {
						day: "numeric",
						month: "short",
						hour: "numeric",
						minute: "numeric",
						hour12: true,
					};
					const userLocalTime = currentTime.toLocaleString(
						"en-GB",
						options,
					);
					const resp =
						await this.mutationAPI.guides.guideMutations.initiateUploadAndSuggestSplits(
							{
								parentId:
									parentID === rootCollection.id
										? undefined
										: parentID,
								userTime: userLocalTime,
								fileFormat: fileFormat,
								videoFileName: file.fileName,
							},
						);
					if (!resp.ok) return [null, this.handleUploadErrors(resp)];

					const { collectionId, url } = resp.body;
					const status = await uploadToPresignedXhr(
						file.file as Blob,
						url,
						progressCallback,
						this.captureEvent,
					);
					if (!status) return [null, UploadErrorCode.S3UploadError];

					const res =
						await this.mutationAPI.guides.guideMutations.finishUploadAndSuggestSplits(
							{
								collectionId: collectionId,
								languageId: languageId,
							},
						);
					if (!res.ok) return [null, this.handleUploadErrors(res)];
					return [collectionId, UploadErrorCode.OK];
				} catch (error) {
					return [null, this.handleUploadErrors(error)];
				}
			},
			generateGuidesBasedOnSplits: async (
				collectionId: GigaUserApi.Id,
				videoChapters: CutsVideoChapters,
				languageId: string,
			) => {
				const res =
					await this.mutationAPI.guides.guideMutations.generateGuidesBasedOnSplits(
						{
							collectionId: collectionId,
							videoChapters: videoChapters,
							languageId: languageId,
						},
					);
				if (res.ok) return res.body;
				else return false;
			},
			saveAudio: async (
				guideId: GigaUserApi.Id,
				autoUpdate: GigaUserApi.Id | undefined,
			) => {
				const id = await this.mutationAPI.audio.saveGuideAudioUpdated({
					guideId: guideId,
					updateId: autoUpdate,
				});
				if (id.ok) {
					return id.body as any;
				} else {
					return null;
				}
			},
			finish: async (request: FinishCreateGuideRequest) => {
				const id =
					await this.mutationAPI.guides.guideMutations.finishCreateGuide(
						request,
					);
				if (id.ok) {
					return id.body;
				} else {
					this.captureEventChrext(
						"Chrext-ErrorFinishingCreateGuideResponse",
						{
							guide_id: request.id,
							error: JSON.stringify(id.error),
						},
					);
					return null;
				}
			},
			emptyTextGuide: async (parentId?: GigaUserApi.Id) => {
				const resp =
					await this.mutationAPI.guides.guideMutations.createEmptyTextGuide(
						{
							parentId:
								parentId === rootCollection.id
									? undefined
									: parentId,
						},
					);

				if (resp.ok) {
					return resp.body;
				} else {
					return false;
				}
			},
		},
		export: {
			video: async (guide: Guide, captions = false) => {
				/**
				 * callback :
				 *      @param status true if succeeded. false if failed.
				 *      @param url presigned_url of the exported file.
				 */

				const a =
					await this.mutationAPI.guides.guideExports.exportVideo({
						guideId: guide.id,
						captions,
					});
				this.handleErrors(a);
				return a;
			},
			checkForSingleUseSubscription: async (guideId: GigaUserApi.Id) => {
				const res =
					await this.mutationAPI.organizations.subscriptions.isSingleUseAvailable(
						guideId,
					);
				this.handleErrors(res);
				return res;
			},
			gif: async (guide: Guide, gifSettings?: GifSettings) => {
				/**
				 * callback :
				 *      @param status true if succeeded. false if failed.
				 *      @param url presigned_url of the exported file.
				 */

				const res =
					await this.mutationAPI.guides.guideExports.exportGif({
						guideId: guide.id,
						gifSettings: gifSettings || {},
					});
				this.handleErrors(res);
				return res;
			},

			getPastExports: async (guideId: GigaUserApi.Id) => {
				const res =
					await this.mutationAPI.guides.guideExports.getPastExports({
						guideId: guideId,
					});

				this.handleErrors(res);
				return res;
			},

			article: async (
				guide: Guide,
				html: string,
				markdown: string,
				onUnsubscribed?: (admins?: UserInOrg[]) => void,
			) => {
				// const {id, guidePreview, guideData} = guide
				// const richTextData : RichTextData = cleanJSON(JSON.parse(JSON.stringify(guideData.plainDoc.data)))
				// const sanitisedGuide : Guide = JSON.parse(JSON.stringify(guide))
				// sanitisedGuide.guideData.plainDoc.data = richTextData
				// if (sanitisedGuide.guideData.video.generated){
				//     sanitisedGuide.guideData.video.generated.transcript = cleanJSON(JSON.parse(JSON.stringify(sanitisedGuide.guideData.video.generated.transcript)))
				// }

				// const updateData = await this.mutationAPI.guides.guideMutations.exportGuide({guide: sanitisedGuide})

				const res =
					await this.mutationAPI.guides.guideExports.exportArticle({
						guideId: guide.id,
					});

				if (res.ok) {
					const imagePresignedURLs = res.body.imagePresignedUrls;
					const promiseArray = getDataUris(html).map((src, index) =>
						uploadToPresigned(
							dataURItoBlob(src),
							imagePresignedURLs[index],
							this.captureEvent,
						),
					);

					await Promise.all(promiseArray);
					return {
						...getHTMLandTextWithImages(
							html,
							markdown,
							res.body.hostedImageUrls,
						),
						// videoOutput: updateData.body.hostedVideoUrl
					};
				} else {
					if (res.error.error === "UnsubscribedOrgError") {
						onUnsubscribed?.(res.error.content.admins);
					}
					return false;
				}
			},
		},
		exportV2: {
			video: async (guide: Guide, captions = false) => {
				const a =
					await this.mutationAPI.guides.guideExports.exportVideoV2({
						guideId: guide.id,
						captions,
					});
				this.handleErrors(a);
				return a;
			},
			gif: async (guide: Guide, gifSettings: GifSettings) => {
				const a =
					await this.mutationAPI.guides.guideExports.exportGifV2({
						guideId: guide.id,
						gifSettings: gifSettings,
					});
				this.handleErrors(a);
				return a;
			},
		},
		convert: {
			gif: async (
				guide: Guide,
				gifSettings: GifSettings,
				callback: (
					status: boolean,
					resp: ConvertToGifResponse | undefined,
				) => void,
			) => {
				/**
				 * callback :
				 *      @param status true if succeeded. false if failed.
				 *      @param url presigned_url of the exported file.
				 */

				const res =
					await this.mutationAPI.guides.guideExports.convertToGif({
						guideId: guide.id,
						gifSettings: gifSettings,
					});

				if (res?.ok) {
					callback(true, res.body);
				} else {
					callback(false, undefined);
				}
			},
		},
		voiceover: {
			generate: async (guideId: GigaUserApi.Id) => {
				const a =
					await this.mutationAPI.guides.guideMutations.generateVoiceover(
						{
							guideId: guideId,
						},
					);
				this.handleErrors(a);
				return a;
			},
		},
		user: {
			get: async (guideId: GigaUserApi.Id) => {
				return await this.userAPI.users.getUserForGuide(guideId);
			},
		},
		inlineEnhance: async (text: string, prompt: string) => {
			const resp =
				await this.mutationAPI.guides.aiEnhance.inlineEnhanceText({
					prompt: prompt,
					text: text,
				});
			this.handleErrors(resp);
			return resp;
		},
		autoTranslate: async (guideId: GigaUserApi.Id, language: Language) => {
			const resp =
				await this.mutationAPI.guides.aiEnhance.translateGuideAndDuplicate(
					{
						guideId: guideId,
						destinationLanguage: language,
						sourceLanguage: Id("en"),
					},
				);
			this.handleErrors(resp);
			return resp;
		},
		publish: async (
			guide: Guide,
			callbacks?: {
				onSuccess?: () => void;
			},
		) => {
			const a = await this.mutationAPI.guides.guideMutations.publishGuide(
				{
					guideId: guide.id,
				},
			);
			this.handleErrors(a);
			if (a.ok) {
				callbacks?.onSuccess?.();
			}
			return a;
		},
		publishV2: async (
			guide: Guide,
			callbacks?: {
				onSuccess?: () => void;
				onAsyncJob?: () => void;
			},
		) => {
			const a =
				await this.mutationAPI.guides.guideMutations.publishGuideV2({
					guideId: guide.id,
				});
			this.handleErrors(a);
			if (a.ok) {
				if (a.body.reExporting) {
					callbacks?.onAsyncJob?.();
				} else {
					callbacks?.onSuccess?.();
				}
			}
			return a;
		},

		duplicate: async (guideId: GigaUserApi.Id) => {
			return await this.mutationAPI.guides.guideMutations.duplicateGuide({
				guideId: guideId,
			});
		},
		platformStatus: {
			get: async (guideId: GigaUserApi.Id) => {
				return await this.mutationAPI.guides.guidePlatformStatus.getStatus(
					{
						guideId: guideId,
					},
				);
			},

			markErrorViewed: async (guideId: GigaUserApi.Id) =>
				this.mutationAPI.guides.guidePlatformStatus.markErrorViewed({
					guideId: guideId,
				}),
		},
		shareableLink: {
			get: async (guidePreview: GuidePreview) => {
				let isPrivate = false;
				let hasPrivateParent = false;
				let fullPath: [Collection, ...Collection[]] = [rootCollection];

				if (!guidePreview.header.published) {
					isPrivate = true;
				}

				if (
					!guidePreview.parentId ||
					guidePreview.parentId === rootCollection.id
				) {
					isPrivate = !guidePreview.header.published;
					hasPrivateParent = false;
				} else {
					const res = await globalSaver.selectedRegionalSaver.getPath(
						guidePreview.parentId,
					);
					if (res) {
						fullPath = res;
						fullPath.map((collection) => {
							if (collection.private) {
								isPrivate = true;
								hasPrivateParent = true;
							}
						});
					}
				}

				return {
					sharingLink: `https://${this.hostname}/${isPrivate ? "share" : "guide"}/${guidePreview.id}`,
					path: fullPath,
					hasPrivateParent,
					isPrivate,
				};
			},
		},

		sources: {
			upload: {
				initiate: async (guideId: GigaUserApi.Id, mime: string) => {
					const post =
						await this.mutationAPI.guides.guideMutations.initiateUploadSource(
							{
								guideId,
								fileType: mime,
							},
						);

					return post;
				},
				finish: async (req: FinishUploadSourceRequest) => {
					return await this.mutationAPI.guides.guideMutations.finishUploadSource(
						req,
					);
				},
			},
		},
		enhance: {
			article: async (request: GuideRequest) => {
				const resp =
					await this.mutationAPI.guides.aiEnhance.enhanceArticleAsync(
						request,
					);
				this.handleErrors(resp);
				return resp;
			},
			videoTranscript: async (request: GuideRequest) => {
				const resp =
					await this.mutationAPI.guides.aiEnhance.enhanceVideoTranscriptAsync(
						request,
					);
				this.handleErrors(resp);
				return resp;
			},
		},
	};
	fonts = {
		getAll: async () => {
			if (this.fontsLoaded) {
				return this.fontsLoaded;
			}
			this.fontsLoaded = await getFonts();
			return this.fontsLoaded;
		},
	};
	collections = {
		delete: async (collectionID: GigaUserApi.Id) => {
			const resp =
				await this.mutationAPI.collections.collectionMutations.deleteCollection(
					{
						id: collectionID,
					},
				);
			return resp.ok;
		},
		update: async (_collection: Collection) => {
			/**
			 * Used to update the Collection. NOT to be used for moving or reordering!
			 * (description, name, published)
			 */

			const collection = { ..._collection };

			const res =
				await this.mutationAPI.collections.collectionMutations.updateCollection(
					collection,
				);

			if (res.ok) {
				return res;
			} else {
				return false;
			}
		},
		visibility: {
			set: async (_collection: Collection, isPrivate: boolean) => {
				const collection = { ..._collection };

				const res =
					await this.mutationAPI.collections.collectionMutations.setCollectionVisibility(
						{
							collection: collection,
							private: isPrivate,
						},
					);

				if (res.ok) {
					return res;
				} else {
					return false;
				}
			},
		},
		move: async (collection: Collection, newParentId?: GigaUserApi.Id) => {
			/**
			 * Use this function to move a guide to a new collection
			 */

			const res =
				await this.mutationAPI.collections.collectionMutations.moveCollection(
					{
						collection: collection,
						newParentId: newParentId,
					},
				);

			if (res.ok) {
				return res.body;
			} else {
				return false;
			}
		},
		reorder: async (
			succeedingCollection: Collection,
			precedingCollection?: Collection,
		) => {
			/**
			 * Used to reorder the sequence_number. SucceedingGuide is placed after precedingGuide
			 */

			const res =
				await this.mutationAPI.collections.collectionMutations.reorderCollection(
					{
						succeedingCollection,
						precedingCollection,
					},
				);

			logger.debug("res: ", res);

			if (res.ok) return res;
			else return false;
		},
		create: async (collection: CollectionInput) => {
			try {
				logger.debug("collectioninput: ", collection);
				const resp =
					await this.mutationAPI.collections.collectionMutations.createCollection(
						collection,
					);
				if (resp?.ok) {
					logger.debug("created collection: ", resp.body);
					return resp.body;
				} else {
					logger.error("could not create collection: ", resp);
					return false;
				}
			} catch (e) {
				logger.error("could not create collection: ", e);
				return false;
			}
		},
		fetch: async (
			collectionId: GigaUserApi.Id,
			withPresignedUrl = false,
		) => {
			const resp =
				await this.mutationAPI.collections.collectionMutations.fetchCollectionData(
					{
						collectionId: collectionId,
						withPresignedUrl: withPresignedUrl,
					},
				);
			if (resp.ok) {
				return resp.body;
			} else {
				return false;
			}
		},
		getChildGuidesCreationStatus: async (collectionId: GigaUserApi.Id) => {
			const resp =
				await this.mutationAPI.collections.collectionMutations.getChildGuidesCreationStatus(
					{
						collectionId: collectionId,
					},
				);
			if (resp.ok) {
				return resp.body;
			} else {
				return false;
			}
		},
	};

	prompts = {
		create: async (prompt: Prompt) => {
			try {
				const resp = await this.mutationAPI.guides.prompts.createPrompt(
					{
						prompt: prompt,
					},
				);
				if (resp?.ok) {
					return resp.body;
				} else {
					return false;
				}
			} catch (e) {
				return false;
			}
		},

		get: async (promptType: PromptType, guideId: GigaUserApi.Id) => {
			try {
				const resp = await this.mutationAPI.guides.prompts.getPrompts({
					promptType: promptType,
					guideId: guideId,
				});

				if (resp?.ok) {
					logger.debug();
					return resp.body;
				} else {
					return false;
				}
			} catch (_e) {
				logger.error("");
			}
		},

		update: async (prompt: PromptOption) => {
			try {
				const resp = await this.mutationAPI.guides.prompts.updatePrompt(
					{
						prompt: prompt,
					},
				);

				if (resp?.ok) {
					return resp.body;
				} else {
					return false;
				}
			} catch (e) {
				return false;
			}
		},

		delete: async (prompt: PromptOption) => {
			try {
				const resp = await this.mutationAPI.guides.prompts.deletePrompt(
					{
						prompt: prompt,
					},
				);

				if (resp?.ok) {
					return resp.body;
				} else {
					return false;
				}
			} catch (e) {
				return false;
			}
		},

		apply: async (
			promptId: GigaUserApi.Id,
			promptType: PromptType,
			guideId: GigaUserApi.Id,
			makeDefault?: boolean,
		) => {
			try {
				const resp = await this.mutationAPI.guides.prompts.applyPrompt({
					promptId: promptId,
					guideId: guideId,
					promptType: promptType,
					makeDefault: makeDefault,
				});

				if (resp?.ok) {
					return resp.body;
				} else {
					return false;
				}
			} catch (_e) {
				return false;
			}
		},
	};

	integrations = {
		loadIntegrations: async () => {
			try {
				const resp =
					await this.mutationAPI.integrations.integrationSetup.loadIntegrations();

				if (resp?.ok) {
					return resp.body;
				} else {
					return false;
				}
			} catch (e) {
				return false;
			}
		},

		slack: {
			checkSlackIntegration: async () => {
				try {
					const resp =
						await this.mutationAPI.integrations.slack.checkSlackIntegration();

					if (resp?.ok) {
						return resp.body;
					} else {
						return false;
					}
				} catch (e) {
					return false;
				}
			},
			getAuthUrl: async (sourceUrl: string) => {
				try {
					const resp =
						await this.mutationAPI.integrations.slack.getAuthUrl({
							sourceUrl: sourceUrl,
						});
					if (resp?.ok) {
						return resp.body;
					} else {
						return false;
					}
				} catch (e) {
					return false;
				}
			},

			handleOauthCallback: async (
				code: string,
				sourceUrl: string,
				state?: string,
			) => {
				return await this.mutationAPI.integrations.slack.handleOAuthCallback(
					{
						code: code,
						state: state,
						sourceUrl: sourceUrl,
					},
				);
			},

			disconnectIntegration: async (
				sourceUrl: string,
			): Promise<string> => {
				try {
					const resp =
						await this.mutationAPI.integrations.slack.disconnectIntegration(
							{
								sourceUrl: sourceUrl,
							},
						);

					if (resp?.ok) {
						return resp.body;
					} else {
						return "";
					}
				} catch (e) {
					return "";
				}
			},

			getChannels: async () => {
				try {
					const resp =
						await this.mutationAPI.integrations.slack.getChannels();

					if (resp?.ok) {
						return resp.body;
					} else {
						return false;
					}
				} catch (_e) {
					return false;
				}
			},

			// getChannels: async () => {
			// 	return await this.mutationAPI.slack.getChannels();
			// },
		},

		youtube: {
			getAuthUrl: async (sourceUrl: string) => {
				try {
					const res =
						await this.mutationAPI.integrations.youtube.getAuthUrl({
							sourceUrl: sourceUrl,
						});

					if (res.ok) {
						return res.body;
					} else {
						console.error("Failed to fetch auth URL", res.error);
					}
				} catch (error) {
					console.error(
						"An error occurred while fetching the auth URL:",
						error,
					);
				}
			},

			handleOAuthCallback: async (a: {
				code: string;
				sourceUrl: string;
				state?: string;
			}) => {
				const { code, sourceUrl, state } = a;

				console.log("   code: ", code);
				console.log("   sourceUrl: ", sourceUrl);
				console.log("   state: ", state);

				return await this.mutationAPI.integrations.youtube.handleOAuthCallback(
					{
						code: code,
						state: state,
						sourceUrl: sourceUrl,
					},
				);
			},

			getIntegrationDetails: async () => {
				try {
					const res =
						await this.mutationAPI.integrations.youtube.getIntegrationDetails();
					if (res.ok) {
						return res.body;
					} else {
						console.error(
							"Failed to fetch youtube integration profile",
							res.error,
						);
					}
				} catch (err) {
					console.log(
						"An error occurred while fetching the integration details:",
						err,
					);
				}
			},

			getPlayListsDetails: async () => {
				try {
					const res =
						await this.mutationAPI.integrations.youtube.getPlayListsDetails();
					if (res.ok) {
						return res.body;
					} else {
						console.error(
							"Failed to fetch youtube playlists details",
							res.error,
						);
					}
				} catch (err) {
					console.log(
						"An error occurred while fetching the playlists details:",
						err,
					);
				}
			},

			publishToYoutube: async (
				guideId: GigaUserApi.Id,
				title: string,
				description: string,
				visibility: VisibilityStatus,
				playlistIds: string[],
			) => {
				try {
					const res =
						await this.mutationAPI.integrations.youtube.publishToYouTube(
							{
								guideId: guideId,
								title: title,
								description: description,
								visibility: visibility,
								playlistIds: playlistIds,
							},
						);

					return res;
				} catch (err) {
					console.log(err);
				}
			},

			disconnectIntegration: async (
				sourceUrl: string,
			): Promise<string> => {
				try {
					const resp =
						await this.mutationAPI.integrations.youtube.disconnectIntegration(
							{
								sourceUrl: sourceUrl,
							},
						);

					if (resp?.ok) {
						return resp.body;
					} else {
						return "";
					}
				} catch (e) {
					return "";
				}
			},
		},
	};

	broadcasts = {
		getBroadcasts: async () => {
			try {
				const resp =
					await this.mutationAPI.guides.broadcasts.getBroadcasts();

				if (resp?.ok) {
					return resp.body;
				} else {
					return false;
				}
			} catch (_e) {
				return false;
			}
		},

		createBroadcast: async (title: string) => {
			try {
				const resp =
					await this.mutationAPI.guides.broadcasts.createBroadcast({
						title: title,
					});
				if (resp?.ok) {
					return resp.body;
				} else {
					return false;
				}
			} catch (e) {
				return false;
			}
		},

		deleteBroadcast: async (id: GigaUserApi.Id) => {
			try {
				const resp =
					await this.mutationAPI.guides.broadcasts.deleteBroadcast(
						id,
					);
				if (resp?.ok) {
					return resp.body;
				} else {
					return false;
				}
			} catch (e) {
				return false;
			}
		},

		getBroadcast: async (id: GigaUserApi.Id) => {
			try {
				const resp =
					await this.mutationAPI.guides.broadcasts.getBroadcast(id);
				console.log("resp of getBroadcast: ", resp);

				if (resp?.ok) {
					return resp.body;
				} else {
					return false;
				}
			} catch (e) {
				return false;
			}
		},

		sendBroadcast: async (
			broadcastId: GigaUserApi.Id,
			channels: SlackChannel[],
		) => {
			try {
				const resp =
					await this.mutationAPI.guides.broadcasts.sendBroadcast({
						broadcastId: broadcastId,
						channels: channels,
					});

				if (resp?.ok) {
					return resp.body;
				} else {
					return false;
				}
			} catch (e) {
				return false;
			}
		},

		updateBroadcast: async (
			id: GigaUserApi.Id,
			changes: {
				message: string;
				platforms: BroadcastPlatform[];
				title: string;
			},
		) => {
			try {
				const resp =
					await this.mutationAPI.guides.broadcasts.updateBroadcast({
						id: id,
						platforms: changes.platforms,
						title: changes.title,
						message: changes.message,
					});
				if (resp?.ok) {
					return resp.body;
				} else {
					return false;
				}
			} catch (e) {
				return false;
			}
		},

		initiateBroadcastIconUpload: async () => {
			try {
				const resp =
					await this.mutationAPI.guides.broadcasts.initiateBroadcastIconUpload();

				if (resp?.ok) {
					return resp.body;
				} else {
					return false;
				}
			} catch (e) {
				return false;
			}
		},

		customizeBroadcastBot: async (
			iconId: GigaUserApi.Id,
			bot: BroadcastBot,
		) => {
			try {
				const resp =
					await this.mutationAPI.guides.broadcasts.customizeBroadcastBot(
						{
							iconId: iconId,
							bot: bot,
						},
					);

				if (resp?.ok) {
					return resp.body;
				} else {
					return false;
				}
			} catch (e) {
				return false;
			}
		},
	};

	newBackgrounds = {
		addBackgroundToOrganization: async (
			background: AddBackgroundToOrganizationRequest,
		) => {
			const resp =
				await this.mutationAPI.templates.addBackgroundToOrganization({
					id: background.id,
					src: background.src,
					premadeBackgroundId: background.premadeBackgroundId,
					backgroundType: background.backgroundType,
					color: background.color,
				});

			if (resp?.ok) return true;
			return false;
		},

		toggleStarBackground: async (id: GigaUserApi.Id) => {
			const resp = await this.mutationAPI.templates.toggleStarBackground({
				id,
			});

			if (resp?.ok) return true;
			return false;
		},

		deleteBackgroundV2: async (id: GigaUserApi.Id) => {
			const resp = await this.mutationAPI.templates.deleteBackgroundV2({
				id,
			});

			if (resp?.ok) return true;
			return false;
		},

		setDefaultBackgroundV2: async (id: GigaUserApi.Id) => {
			const resp =
				await this.mutationAPI.templates.setDefaultBackgroundV2({
					id,
				});
			if (resp?.ok) return resp.body;
			return false;
		},
	};

	newTemplates = {
		createOrganizationTemplate: async (
			template: CreateOrganizationTemplateRequest,
		) => {
			return await this.mutationAPI.templates.createOrganizationTemplate(
				template,
			);
		},

		deleteOrganizationTemplate: async (id: GigaUserApi.Id) => {
			return await this.mutationAPI.templates.deleteOrganizationTemplate({
				id,
			});
		},

		setDefaultTemplate: async (type: CoverType, id: GigaUserApi.Id) => {
			return await this.mutationAPI.templates.setDefaultTemplate({
				id,
				clipLabel: type,
			});
		},
	};

	getEventData = async ({
		startDate,
		endDate,
		guideId,
	}: {
		startDate?: Date;
		endDate?: Date;
		guideId?: string;
	}) => {
		const urlEncodedStartDate = startDate
			? encodeURIComponent(startDate.toISOString())
			: undefined;

		const urlEncodedEndDate = endDate
			? encodeURIComponent(endDate.toISOString())
			: undefined;

		return await this.mutationAPI.analytics.getEventData({
			startDate: urlEncodedStartDate,
			endDate: urlEncodedEndDate,
			guideId: guideId ? encodeURIComponent(guideId) : undefined,
		});
	};

	getAssociatedOrganizations = async () => {
		if (this.associateOrgs) {
			return this.associateOrgs;
		}
		const res = await this.mutationAPI.users.getAssociatedOrgs();
		if (res.ok) {
			this.associateOrgs = res.body;
			return res.body;
		} else {
			return [];
		}
	};

	getAllLanguages = async () => {
		if (this.languages && this.languages.length > 0) {
			return this.languages;
		}
		const res =
			await this.mutationAPI.organizations.organization.getAllLanguages();
		if (res.ok) {
			this.languages = res.body.languages;
			return res.body.languages;
		} else return [];
	};

	getAllLanguagesChrext = async () => {
		if (this.languages && this.languages.length > 0) {
			return this.languages;
		}
		const res =
			await this.mutationAPI.organizations.organization.getAllLanguagesChrext();
		if (res.ok) {
			this.languages = res.body.languages;
			return res.body.languages;
		} else return [];
	};

	getLanguage = async (languageId: string) => {
		const allLanguages = await this.getAllLanguages();
		const language = allLanguages.find((l) => l.languageId === languageId);
		return language;
	};

	getVoices = async () => {
		if (this.voices) {
			return this.voices;
		}

		const res =
			await this.mutationAPI.organizations.organization.getVoices();

		if (res.ok) {
			this.voices = res.body.voices;
			return res.body.voices;
		} else return [];
	};
	getAllDefaultVoices = async () => {
		const res =
			await this.mutationAPI.organizations.organization.getAllDefaultVoices();
		if (res.ok) {
			return res.body.defaultVoices;
		}
		return [];
	};

	getOrgUsers = async () => {
		const res = await this.mutationAPI.admin.getUsers();
		if (res.ok) {
			return res.body;
		}
		return [];
	};

	createUser = async (user: User) => {
		const res = await this.mutationAPI.admin.createUser(user);
		return res;
	};

	deleteUser = async (email: string) => {
		const res = await this.mutationAPI.admin.deleteUser(email);
		if (res.ok) {
			return res.body;
		}
		return false;
	};

	getHostingDetails = async () => this.mutationAPI.admin.getHostingDetails();
	setHostingDetails = async (x: HostingDetails) =>
		this.mutationAPI.admin.setHostingDetails(x);

	// #region -- TEMPLATES --

	getPlatformDetails = async () =>
		this.mutationAPI.organizations.organization.getPlatformDetails();

	uploadBackgroundAudio = async (file: any, description: string) => {
		const track =
			await this.mutationAPI.audio.initiateBackgroundAudioUpload();
		if (track.ok) {
			const resp = await uploadToPresigned(
				file,
				track.body.url,
				this.captureEvent,
			);
			if (resp) {
				const trackId =
					await this.mutationAPI.audio.finishCreateBackgroundAudioUpload(
						{
							src: track.body.src,
							description: description,
						},
					);
				if (trackId.ok) {
					return { src: track.body.src, description: description };
				}
			}
		}
		return null;
	};

	deleteAudio = async (src: string, description: string) => {
		const resp = await this.mutationAPI.audio.deleteAudio({
			src,
			description,
		});
		if (resp.ok) {
			return true;
		} else {
			return false;
		}
	};

	favoriteAudio = async (src: string, description: string) => {
		const resp = await this.mutationAPI.audio.favoriteAudio({
			src,
			description,
		});

		return resp;
	};

	unfavoriteAudio = async (src: string, description: string) => {
		const resp = await this.mutationAPI.audio.unfavoriteAudio({
			src,
			description,
		});

		return resp;
	};

	uploadLogo = async (file: any) => {
		const logo = await this.mutationAPI.templates.initiateLogoUpload();
		if (logo.ok) {
			const { id, src } = logo.body;
			const resp = await uploadToPresigned(
				file,
				logo.body.url,
				this.captureEvent,
			);
			if (resp) {
				const finishResp =
					await this.mutationAPI.templates.finishLogoUpload({
						id: id,
						src: logo.body.src,
					});
				if (finishResp.ok) {
					return { id: id, src: src };
				}
			}
		}
	};

	uploadAsset = async () => {
		const post = await this.mutationAPI.templates.initiateAssetUpload();
		return post;
	};

	createCover = async (type: CoverType, cover: Cover) => {
		return await this.mutationAPI.templates.createCover({
			cover: cover,
			type: type,
		});
	};

	createBackground = async (background: Background) => {
		return await this.mutationAPI.templates.createBackground({
			background,
		});
	};

	deleteCover = async (type: CoverType, id: GigaUserApi.Id) => {
		const resp = await this.mutationAPI.templates.deleteCover({
			type,
			id,
		});

		if (resp?.ok) return true;
		return false;
	};

	deleteBackground = async (id: GigaUserApi.Id) => {
		const resp = await this.mutationAPI.templates.deleteBackground({
			id,
		});

		if (resp?.ok) return true;
		return false;
	};

	updateCover = async (type: CoverType, coverOption: CoverOption) => {
		return await this.mutationAPI.templates.updateCover({
			type,
			coverOption,
		});
	};

	setDefaultCover = async (type: CoverType, id: GigaUserApi.Id) => {
		const resp = await this.mutationAPI.templates.setDefaultCover({
			type,
			id,
		});

		if (resp?.ok) return resp.body;
		return false;
	};

	setDefaultBackground = async (id: GigaUserApi.Id) => {
		const resp = await this.mutationAPI.templates.setDefaultBackground({
			id,
		});
		if (resp?.ok) return resp.body;
		return false;
	};

	// #endregion --- TEMPLATES ---

	getUsageVideo = async (req: GetUsageRequest) => {
		return await this.mutationAPI.admin.getUsageVideo(req);
	};

	getUsageArticle = async (req: GetUsageRequest) => {
		return await this.mutationAPI.admin.getUsageArticle(req);
	};

	validateGuideUrlPath = async (req: ValidateGuideUrlRequest) => {
		return await this.mutationAPI.guides.guideMutations.validateGuideUrlPath(
			req,
		);
	};

	validateCollectionUrlPath = async (
		req: ValidateCollectionUrlPathRequest,
	) => {
		return await this.mutationAPI.collections.collectionQueries.validateCollectionUrlPath(
			req,
		);
	};

	listOfEligibleOrganizations = async () => {
		return await this.userAPI.organizations.organizationMutations.listEligibleOrganizations();
	};

	createOrganization = async (req: CreateOrganizationRequest) => {
		return await this.userAPI.organizations.organizationMutations.createOrganization(
			req,
		);
	};

	joinOrganization = async (req: JoinOrganizationRequest) => {
		const resp =
			await this.userAPI.organizations.organizationMutations.joinOrganization(
				req,
			);
		this.handleErrors(resp);
		return resp;
	};

	settings = {
		profile: {
			userData: () => this.user,
		},
		manageUsers: {
			listOfOnboardedCreators: async () => {
				const resp =
					await this.mutationAPI.organizations.organizationMutations.listCreatorsInCurrentOrganization();
				this.handleErrors(resp);
				return resp;
			},
			listOfInvitedCreators: async () => {
				const resp =
					await this.mutationAPI.organizations.organizationMutations.listInvitedUsersInCurrentOrganization();
				this.handleErrors(resp);
				return resp;
			},
			organizationDetails: () => this.organization,
			removeUserFromOrganization: async (
				req: RemoveUserFromOrgRequest,
			) => {
				const resp =
					await this.mutationAPI.organizations.organizationMutations.removeUserFromOrganization(
						req,
					);
				this.handleErrors(resp);
				return resp;
			},
			changeRoleOfUser: async (req: ChangeRoleForUserRequest) => {
				const resp =
					await this.mutationAPI.organizations.organizationMutations.changeRoleForUser(
						req,
					);
				this.handleErrors(resp);
				return resp;
			},
			addUserToOrganization: async (
				req: AddUserToOrganizationRequest,
			) => {
				const resp =
					await this.mutationAPI.organizations.organizationMutations.addUserToOrganization(
						req,
					);
				this.handleErrors(resp);
				return resp;
			},
		},
		openDoorPolicy: {
			getOpenDoorPolicy: async () => {
				const resp =
					await this.mutationAPI.organizations.organizationMutations.getOpenDoorPolicy();
				this.handleErrors(resp);
				return resp;
			},
			changeOpenDoorPolicy: async (req: ChangeOpenDoorPolicyRequest) => {
				const resp =
					await this.mutationAPI.organizations.organizationMutations.changeOpenDoorPolicy(
						req,
					);
				this.handleErrors(resp);
				return resp;
			},
		},
		pronunciationDictionary: {
			getAllLanguages: this.getAllLanguages,
			getPronunciationDictionary: async (req: GetPronDictRequest) => {
				const resp = await this.mutationAPI.settings.fetchPronDict(req);
				this.handleErrors(resp);
				return resp;
			},
			getWordStatus: async (req: GetPronDictEntryRequest) => {
				const resp =
					await this.mutationAPI.settings.getPronDictEntry(req);
				this.handleErrors(resp);
				return resp;
			},
			addWordToPronunciationDictionary: async (
				req: PronDictEntryRequest,
			) => {
				const resp =
					await this.mutationAPI.settings.addPronDictEntry(req);
				this.handleErrors(resp);
				return resp;
			},
			deleteWordFromPronunciationDictionary: async (
				req: PronDictEntryRequest,
			) => {
				const resp =
					await this.mutationAPI.settings.deletePronDictEntry(req);
				this.handleErrors(resp);
				return resp;
			},
			returnPreviewAudioBytes: async (
				req: GeneratePreviewAudioRequest,
			) => {
				const resp =
					await this.mutationAPI.settings.returnPreviewAudioBytes(
						req,
					);
				this.handleErrors(resp);
				return resp;
			},
		},
		manageTeam: {
			listOfOrgsCurrentUserIsAssociatedWith: async () => {
				const resp =
					await this.userAPI.organizations.organizationMutations.listOrganizationsUserIsIn();
				this.handleErrors(resp);
				return resp;
			},
			leaveOrganization: async (req: GigaUserApi.Id) => {
				const resp =
					await this.mutationAPI.organizations.organizationMutations.leaveOrganization(
						req,
					);
				this.handleErrors(resp);
				return resp;
			},
			listOfEligibleOrganizations: this.listOfEligibleOrganizations,
			joinOrganization: this.joinOrganization,
		},
		billingAndUsage: {
			basicUsageInCurrentCycle: async () => {
				const resp =
					await this.mutationAPI.organizations.usageMetrics.getBasicUsageInActivePlan();
				this.handleErrors(resp);
				return resp;
			},
			subscriptionCycles: async () => {
				const resp =
					await this.mutationAPI.organizations.usageMetrics.getSubscriptionCycles();
				this.handleErrors(resp);
				return resp;
			},
			usageMetricsForACycle: async (req: UsageMetricsRequest) => {
				const resp =
					await this.mutationAPI.organizations.usageMetrics.getUsageInSubscriptionCycle(
						req,
					);
				this.handleErrors(resp);
				return resp;
			},
			utilizationReport: async (req: UtilizationRequest) => {
				const resp =
					await this.mutationAPI.organizations.usageMetrics.getUtilizationInACycle(
						req,
					);
				this.handleErrors(resp);
				return resp;
			},
		},
		organizationName: {
			getOrganizationName: async () => {
				const resp =
					await this.mutationAPI.organizations.organizationMutations.getName();
				this.handleErrors(resp);
				return resp;
			},
			changeOrganizationName: async (newName: string) => {
				const resp =
					await this.mutationAPI.organizations.organizationMutations.changeName(
						{
							name: newName,
						},
					);
				this.handleErrors(resp);
				return resp;
			},
		},
		kbSettings: {
			fetchAuthType: async (
				helpcenter_id: GigaUserApi.Id,
			): Promise<[AuthType, AuthErrorCode]> => {
				const resp = await this.mutationAPI.admin.fetchAuthType({
					helpcenterId: helpcenter_id,
				});
				if (!resp.ok) {
					return [
						AuthType.Public,
						this.handleAuthErrors(resp.error.error),
					];
				}
				return [resp.body.currentAuthType, AuthErrorCode.OK];
			},

			setAuthType: async (
				helpcenter_id: GigaUserApi.Id,
				new_auth_type: AuthType,
			) => {
				const resp = await this.mutationAPI.admin.setAuthType({
					helpcenterId: helpcenter_id,
					newAuthType: new_auth_type,
				});
				if (!resp.ok) {
					return this.handleAuthErrors(resp.error.error);
				}
				return AuthErrorCode.OK;
			},

			setPasswordAuthDetails: async (
				helpcenter_id: GigaUserApi.Id,
				password: string,
			) => {
				const resp =
					await this.mutationAPI.admin.setPasswordAuthDetails({
						helpcenterId: helpcenter_id,
						newPassword: password,
					});
				if (!resp.ok) {
					return this.handleAuthErrors(resp.error.error);
				}
				return AuthErrorCode.OK;
			},

			fetchPasswordAuthDetails: async (
				helpcenter_id: GigaUserApi.Id,
			): Promise<[string, AuthErrorCode]> => {
				const resp =
					await this.mutationAPI.admin.fetchPasswordAuthDetails({
						helpcenterId: helpcenter_id,
					});
				if (!resp.ok) {
					return ["", this.handleAuthErrors(resp.error.error)];
				}
				return [resp.body.currentPassword, AuthErrorCode.OK];
			},

			fetchAppAuthDetails: async (
				helpcenter_id: GigaUserApi.Id,
			): Promise<[string, string, AuthErrorCode]> => {
				const resp = await this.mutationAPI.admin.fetchAppAuthDetails({
					helpcenterId: helpcenter_id,
				});
				console.log(resp);
				if (!resp.ok) {
					return ["", "", this.handleAuthErrors(resp.error.error)];
				}
				return [
					resp.body.jwtKey,
					resp.body.redirectUrl,
					AuthErrorCode.OK,
				];
			},

			setAppAuthDetails: async (
				helpcenter_id: GigaUserApi.Id,
				redirect_url: string,
			) => {
				const resp = await this.mutationAPI.admin.setAppAuthDetails({
					helpcenterId: helpcenter_id,
					redirectUrl: redirect_url,
				});
				if (!resp.ok) {
					return this.handleAuthErrors(resp.error.error);
				}
				return AuthErrorCode.OK;
			},

			fetchEmailAuthDetails: async (
				helpcenter_id: GigaUserApi.Id,
			): Promise<[string[], AuthErrorCode]> => {
				const resp = await this.mutationAPI.admin.fetchEmailAuthDetails(
					{
						helpcenterId: helpcenter_id,
					},
				);
				console.log(resp);
				if (!resp.ok) {
					return [[], this.handleAuthErrors(resp.error.error)];
				}
				return [resp.body.allowedEmails, AuthErrorCode.OK];
			},

			setEmailAuthDetails: async (
				helpcenter_id: GigaUserApi.Id,
				emails: string[],
			) => {
				const resp = await this.mutationAPI.admin.setEmailAuthDetails({
					helpcenterId: helpcenter_id,
					allowedEmails: emails,
				});
				if (!resp.ok) {
					return this.handleAuthErrors(resp.error.error);
				}
				return AuthErrorCode.OK;
			},
		},
		videoSettings: {
			getFeatureFlags: async () => {
				const resp = await this.mutationAPI.settings.getFeatureFlags();
				if (!resp.ok) {
					this.handleErrors(resp.error.error);
					return resp;
				}
				return resp;
			},
			setFeatureFlags: async (req: FeatureFlags) => {
				const resp = await this.mutationAPI.settings.setFeatureFlags({
					featureFlags: req,
				});
				this.handleErrors(resp);
				return resp.ok;
			},
		},
	};

	getBasePlanDetails = async () => {
		if (this.basePlanStatus) {
			return this.basePlanStatus;
		}
		const resp =
			await this.mutationAPI.organizations.subscriptions.getBasePlanDetails();
		if (resp.ok) {
			if (
				resp.body.name !== GigaUserApi.organizations.BasePlanName.None
			) {
				this.basePlanStatus = resp.body;
			} else {
				this.basePlanStatus = null;
			}
			return this.basePlanStatus;
		}
		return null;
	};
	getDnsStatus = async () => {
		return await this.mutationAPI.helpcenter.helpcenterMutations.getDnsStatus();
	};

	validateDnsRecord = async (req: UpdateOrValidateDnsRecordRequest) => {
		return await this.mutationAPI.helpcenter.helpcenterMutations.validateDnsRecord(
			req,
		);
	};

	updateDnsRecord = async (req: UpdateOrValidateDnsRecordRequest) => {
		return await this.mutationAPI.helpcenter.helpcenterMutations.updateDnsRecord(
			req,
		);
	};

	setupCustomDomain = async (req: CustomDomainSetupRequest) => {
		const resp =
			await this.mutationAPI.helpcenter.helpcenterMutations.customDomainSetup(
				req,
			);
		this.handleErrors(resp);
		if (!resp.ok) {
			return false;
		}
		return resp.body;
	};

	deleteCustomDomain = async (req: CustomDomainSetupRequest) => {
		return await this.mutationAPI.helpcenter.helpcenterMutations.deleteDomain(
			req,
		);
	};

	verifyDnsSetup = async (req: CustomDomainSetupRequest) => {
		return await this.mutationAPI.helpcenter.helpcenterMutations.verifyDomainSetup(
			req,
		);
	};

	checkout = async (req: CheckoutRequest) => {
		const resp =
			await this.mutationAPI.organizations.subscriptions.checkout(req);
		return resp;
	};

	viewStripePortal = async () => {
		const resp =
			await this.mutationAPI.organizations.subscriptions.viewStripePortal();
		return resp;
	};

	validateCheckout = async (session: string) => {
		const resp =
			await this.mutationAPI.organizations.subscriptions.validateCheckout(
				session,
			);
		return resp;
	};

	checkFeatureAvailablity = async (featureName: string) => {
		const res =
			await this.mutationAPI.organizations.subscriptions.checkFeatureAvailablity(
				{
					featureName: featureName,
				},
			);
		if (res.ok) return res.body;
		else return false;
	};
	sendGuideChatMessage = async (messageData: SendMessageRequest) => {
		const resp =
			await this.mutationAPI.guides.guideAiChat.sendMessage(messageData);

		return resp;
	};

	deleteChatForAGuide = async (messageData: DeleteChatForAGuideRequest) => {
		const resp =
			await this.mutationAPI.guides.guideAiChat.deleteChatForAGuide(
				messageData,
			);

		return resp;
	};

	deleteMessageById = async (messageData: DeleteMessageByIdRequest) => {
		const resp =
			await this.mutationAPI.guides.guideAiChat.deleteMessageById(
				messageData,
			);

		return resp;
	};

	setDefaultTransition = async (messageData: SetDefaultTransitionRequest) => {
		const resp =
			await this.mutationAPI.templates.setDefaultTransition(messageData);
		return resp;
	};
}

export class GlobalSaver {
	api_url: string;
	selectedRegionalSaver!: RegionalSaver;
	availableRegionalSavers: {
		[baseUrl: string]: RegionalSaver;
	} = {};
	baseUrlToOrgIdsMapping: {
		[baseUrl: string]: GigaUserApi.Id[];
	} = {};
	getAccessToken!: () => Promise<string>;
	regionalSaversNotUsedForInitGuideEditor: RegionalSaver[] = [];
	allRegionalSaversUsedForInitGuideEditor = false;
	firstTimeCalledTryInitGuideEditor = true;
	constructor(initData: { api_url: string }) {
		this.api_url = initData.api_url;
	}

	reInit = async (
		getAccessToken: () => Promise<string>,
		forChromeExtension = false,
	) => {
		this.getAccessToken = getAccessToken;

		if (
			!forChromeExtension &&
			process.env.REACT_APP_DEPLOYMENT_ENV === "development"
		) {
			const saver = new RegionalSaver({
				api_url: "http://localhost:8080",
			});
			this.selectedRegionalSaver = saver;
			await saver.initializePlatform(this.getAccessToken, false);
			this.availableRegionalSavers["http://localhost:8080"] = saver;
			return this.selectedRegionalSaver;
		}

		if (
			!forChromeExtension &&
			process.env.REACT_APP_DEPLOYMENT_ENV === "staging"
		) {
			const saver = new RegionalSaver({
				api_url: `https://api.${process.env.REACT_APP_DEPLOYMENT_ENV}.clueso.io`,
			});
			this.selectedRegionalSaver = saver;
			await this.selectedRegionalSaver.initializePlatform(
				this.getAccessToken,
				false,
			);
			this.availableRegionalSavers[
				`https://api.${process.env.REACT_APP_DEPLOYMENT_ENV}.clueso.io`
			] = saver;
			return this.selectedRegionalSaver;
		} else if (
			!forChromeExtension &&
			process.env.REACT_APP_DEPLOYMENT_ENV === "testing"
		) {
			const saver = new RegionalSaver({
				api_url: `https://api.in.${process.env.REACT_APP_DEPLOYMENT_ENV}.clueso.io`,
			});
			this.selectedRegionalSaver = saver;
			await this.selectedRegionalSaver.initializePlatform(
				this.getAccessToken,
				false,
			);
			this.availableRegionalSavers[
				`https://api.in.${process.env.REACT_APP_DEPLOYMENT_ENV}.clueso.io`
			] = saver;
			return this.selectedRegionalSaver;
		}
		// Fetch base URL data
		const resp = await fetch(
			this.api_url + "/united-nations/v1/api/base-url",
			{
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${await this.getAccessToken()}`,
				},
				method: "POST",
			},
		);
		const body = await resp.json();

		if (body.data.noOrgIdsFound) {
			// Handle single region case
			const regionalSaver = new RegionalSaver({
				api_url: body.data.baseUrl,
			});
			this.availableRegionalSavers[body.data.baseUrl] = regionalSaver;

			// Initialize with headful since it's the only saver
			await (forChromeExtension
				? regionalSaver.initializeExtension(this.getAccessToken, false)
				: regionalSaver.initializePlatform(this.getAccessToken, false));

			this.selectedRegionalSaver = regionalSaver;
		} else {
			// Handle multiple regions case
			this.baseUrlToOrgIdsMapping = body.data.baseUrlToOrgIds;

			// Get stored org_id
			const org_id = forChromeExtension
				? (await chrome.storage.local.get("organization_id"))
						.organization_id
				: window.localStorage.getItem("organization_id");

			// Find the matching base URL for the stored org_id
			let selectedBaseUrl = null;
			if (org_id) {
				selectedBaseUrl = Object.entries(
					this.baseUrlToOrgIdsMapping,
				).find(([_, orgIds]) => orgIds.includes(Id(org_id)))?.[0];

				// If org_id exists but no matching baseUrl was found, clear the stored org_id
				if (!selectedBaseUrl) {
					console.warn(
						"Stored organization_id doesn't match any available regions. Clearing stored value.",
					);
					if (forChromeExtension) {
						await chrome.storage.local.remove("organization_id");
					} else {
						window.localStorage.removeItem("organization_id");
					}
				}
			}

			// If no valid selectedBaseUrl was found, use the first available one
			if (!selectedBaseUrl) {
				selectedBaseUrl = Object.keys(this.baseUrlToOrgIdsMapping)[0];
			}
			// console.log("***selectedBaseUrl", selectedBaseUrl);
			// Create and initialize regional savers
			let isPreferrredSaverInited = false;

			// Convert to array first for reliable indexing
			const baseUrlEntries = Object.entries(this.baseUrlToOrgIdsMapping);

			for (let i = 0; i < baseUrlEntries.length; i++) {
				const [baseUrl, orgIds] = baseUrlEntries[i];
				const regionalSaver = new RegionalSaver({ api_url: baseUrl });
				this.availableRegionalSavers[baseUrl] = regionalSaver;

				// Initialize headful if it's the selected base URL, headless otherwise
				const isHeadful = baseUrl === selectedBaseUrl;
				let inited = false;
				try {
					await (forChromeExtension
						? regionalSaver.initializeExtension(
								this.getAccessToken,
								!isHeadful,
							)
						: regionalSaver.initializePlatform(
								this.getAccessToken,
								!isHeadful,
							));
					inited = true;
				} catch (e) {
					// console.error(
					// 	"***caught error initializing regional saver: ",
					// 	baseUrl,
					// 	e,
					// );
					// Skip this regional saver
					// If this is the last regional saver, and no regional saver has been selected, throw the error
					const isLastSaver = i === baseUrlEntries.length - 1;
					if (isLastSaver && !isPreferrredSaverInited) {
						this.selectedRegionalSaver = regionalSaver;
						throw e;
					}
					continue;
				}

				// Set as selected saver if it's the headful one
				if (inited && !isPreferrredSaverInited) {
					// console.log(
					// 	"***resetting selected regional saver",
					// 	regionalSaver.api_url,
					// );
					this.selectedRegionalSaver = regionalSaver;
					if (isHeadful) {
						isPreferrredSaverInited = true;
					}
				}
			}

			// Confirm that selected regional saver has attached
		}

		return this.selectedRegionalSaver;
	};

	getAssociatedOrganizations = async () => {
		const promises = Object.values(this.availableRegionalSavers).map(
			(regionalSaver) => regionalSaver.getAssociatedOrganizations(),
		);

		const results = await Promise.all(promises);

		const x = results.flat().filter(Boolean);
		console.log(x);
		return x;
	};

	joinOrganizations = async (req: JoinOrganizationRequest) => {
		// Group orgIds by their baseUrl
		const orgIdsByBaseUrl: { [baseUrl: string]: GigaUserApi.Id[] } = {};

		for (const { orgId } of req.organizationDetails) {
			for (const [baseUrl, orgIds] of Object.entries(
				this.baseUrlToOrgIdsMapping,
			)) {
				if (orgIds.includes(orgId)) {
					orgIdsByBaseUrl[baseUrl] = orgIdsByBaseUrl[baseUrl] || [];
					orgIdsByBaseUrl[baseUrl].push(orgId);
					break;
				}
			}
		}

		// Make parallel requests for each baseUrl
		const joinPromises = Object.entries(orgIdsByBaseUrl).map(
			([baseUrl, orgIds]) =>
				this.availableRegionalSavers[baseUrl].joinOrganization({
					organizationDetails: orgIds.map((orgId) => ({ orgId })),
					analyticalData: req.analyticalData,
				}),
		);

		return Promise.all(joinPromises);
	};

	tryToUseRegionalSaverForInitGuideEditor = () => {
		const regionalSavers = Object.values(this.availableRegionalSavers);
		if (
			this.regionalSaversNotUsedForInitGuideEditor.length === 0 &&
			!this.allRegionalSaversUsedForInitGuideEditor &&
			this.firstTimeCalledTryInitGuideEditor
		) {
			this.regionalSaversNotUsedForInitGuideEditor =
				regionalSavers.filter(
					(regionalSaver) =>
						regionalSaver.api_url !==
						this.selectedRegionalSaver.api_url,
				);
			this.firstTimeCalledTryInitGuideEditor = false;
			return this.selectedRegionalSaver;
		}
		console.log(
			"regionalSaversNotUsedForInitGuideEditor",
			this.regionalSaversNotUsedForInitGuideEditor,
		);
		const regionalSaver =
			this.regionalSaversNotUsedForInitGuideEditor.pop();
		console.log("regionalSaver", regionalSaver);
		if (!regionalSaver) {
			this.allRegionalSaversUsedForInitGuideEditor = true;
			console.log(
				"all regional savers used for init guide editor",
				this.allRegionalSaversUsedForInitGuideEditor,
			);
			return this.selectedRegionalSaver;
		}
		console.log("regionalSaver", regionalSaver.api_url);
		this.selectedRegionalSaver = regionalSaver;
		return regionalSaver;
	};

	checkAppUpdates = async (appName: "chrext") => {
		const resp = await fetch(
			`${this.api_url}/configs/v1/api/releases/${appName}`,
			{
				cache: "no-store",
				headers: {
					"Cache-Control": "no-cache, no-store, must-revalidate",
					Pragma: "no-cache",
					Expires: "0",
				},
			},
		);
		const body = (await resp.json()) as Configs.CheckConfigResponse;
		return body;
	};
}

export const globalSaver = new GlobalSaver({
	api_url: saverconfig.un_url,
});
